import Vue from 'vue'
import Router from 'vue-router'
import web from '@/components/common/web'
import noticeDetail from '@/components/medium/noticeDetail';
import leaveMessages from '@/components/other/leaveMessages';
Vue.use(Router)

export default new Router({
    base:"custom",
    mode: 'history',
    routes: [
        {
            path: '/web',
            name: 'web',
            component: web
        },
        {
            path: '/noticeDetail',
            name: 'noticeDetail',
            component: noticeDetail
        },
        {
            path: '/leaveMessages',
            name: 'leaveMessages',
            component: leaveMessages
        },
    ]
})
